export default "__VITE_ASSET__26a8d108__"